"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _shared = require("../shared");

// fontSizes: [10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 42, 48, 54]

/**
 * By default text primitives will have a margin of 0, but can pass preserveUserAgentMargins prop to, well, preserve the user agent stylesheet margins.
 * This is needed to update text tags (including styled components) that rely on user agent margins, so they can be turned into primitives without changing their styles.
 * Do a hard check as a boolean, no truthy values allowed >:D
 * I think this is safe, but could add a default value of false to the Text component in index.js here if desired for more surety.
 */
var _default = (0, _styledComponents.css)(["margin:", ";", ";"], function (_ref) {
  var preserveUserAgentMargins = _ref.preserveUserAgentMargins;
  return preserveUserAgentMargins === true ? null : 0;
}, _shared.defaultSystemProps);

exports["default"] = _default;